const state = {
  rush: [{ name: 'Y' }, { name: 'N' }],
  paginationcount: [{ name: '5' }, { name: '10' }, { name: '25' }, { name: '50' }]
};

export default {
  namespaced: true,
  state,
  actions: {
    fetchRush({ commit }, payload) {},
    fetchPaginationCount({ commit }, payload) {}
  }
};
